import React, { useState } from "react";
import { doFetch } from "storybook-dashboard/utils/fetching";

import { confirmDelete, confirmProceed } from "traec-react/utils/sweetalert";
import IndicatorRow from "./equations";

import { CreateIndicatorForm } from "./form";
import { MetricTargetSet } from "AppSrc/dashboards/targetSet";
import { ErrorBoundary } from "storybook-dashboard/errors/handleError";
import { useProjectPermissions } from "storybook-dashboard/utils/hooks";
import { Modal, useModal } from "storybook-dashboard/components/modal";

import { Hide } from "storybook-dashboard/utils";

import Im from "immutable";

const getDropDownLinks = (props) => {
  let { indicator, showTargetForm } = props;
  let metricTarget = indicator.get("metricTarget");
  let raThreshold = metricTarget ? metricTarget.getIn(["meta_json", "thresholdLow"]) : null;
  let greenBelow = metricTarget ? metricTarget.getIn(["meta_json", "greenBelow"]) : null;

  let items = [
    //{ name: "Edit Indicator", onClick: this.editIndicator },
    //{},
    { name: "Set Targets", onClick: () => showTargetForm() },
    {
      name: "Set Cumulative Target",
      linkTo: cumulativeTargetLink(props),
    },
    {},
    { name: "Add to all Reports", onClick: () => addRetro(props) },
    {},
    { name: "Delete", onClick: () => deleteIndicator(props) },
  ];
  if (metricTarget && !raThreshold) {
    let name = greenBelow ? "Set Green Above Target" : "Set Green Below Target";
    items.push({ name: name, onClick: () => toggleGreenBelow(props) });
  }
  if (indicator.get("metricTarget")) {
    items.push({ name: "Delete Target", onClick: () => deleteTarget(props) });
  }
  return items;
};

const cumulativeTargetLink = (props) => {
  let { isRootRef, indicator, projectId, refId } = props;
  if (isRootRef) {
    return `/project/${projectId}/indicator/${indicator.get("uid")}/target`;
  } else {
    return `/project/${projectId}/wpack/${refId}/indicator/${indicator.get("uid")}/target`;
  }
};

const addRetro = (props) => {
  let { indicator, trackerId, commitId } = props;
  let indicatorId = indicator.get("uid");
  let indicatorName = indicator.getIn(["metric", "name"]) || "";

  confirmProceed({
    text: `This will add this indicator ${indicatorName} to all reports in this Reporting Package, including past reports that did not include the indicator at the time.  Are you sure you would like to proceed?`,
    onConfirm: () => {
      doFetch(`/api/tracker/${trackerId}/commit/${commitId}/indicator/${indicatorId}/`, "PATCH", {
        apply_ref_all: true,
      });
    },
  });
};

const deleteIndicator = (props) => {
  let { indicator, trackerId, commitId, triggerIndicators } = props;
  let indicatorId = indicator.get("uid");
  let indicatorName = indicator.get("name") || indicator.getIn(["result_metric", "name"]) || "";

  console.log("Deleting indicator", indicatorId, trackerId, commitId, indicatorName);

  confirmDelete({
    text: `This will delete this indicator ${indicatorName}.  Are you sure you would like to proceed?`,
    onConfirm: () => {
      doFetch(`/api/tracker/${trackerId}/commit/${commitId}/indicator/${indicatorId}/`, "DELETE")
        .then(() => (triggerIndicators ? triggerIndicators() : null))
        .catch((error) => {
          console.error("Error deleting indicator", error);
        });
    },
  });
};

const deleteTarget = (props) => {
  let { trackerId, commitId, indicator, triggerTargets } = props;
  let indicatorName = indicator.getIn(["metric", "name"]) || "";
  let metricTargetId = indicator.getIn(["metricTarget", "uid"]) || null;
  if (!metricTargetId) {
    return null;
  }

  confirmDelete({
    text: `This will delete the target set for indicator ${indicatorName}.  Are you sure you would like to proceed?`,
    onConfirm: () => {
      doFetch(`/api/tracker/${trackerId}/commit/${commitId}/target/${metricTargetId}/?all_ref=true`, "DELETE")
        .then(() => (triggerTargets ? triggerTargets() : null))
        .catch((error) => {
          console.error("Error deleting target", error);
        });
    },
  });
};

const toggleGreenBelow = (props) => {
  let { trackerId, commitId, indicator, triggerTargets } = props;
  let metricTarget = indicator.get("metricTarget");
  if (!metricTarget) {
    return null;
  }
  let metricTargetId = metricTarget.get("uid") || null;
  let greenBelow = metricTarget ? metricTarget.getIn(["meta_json", "greenBelow"]) : null;

  doFetch(`/api/tracker/${trackerId}/commit/${commitId}/target/${metricTargetId}/`, "PATCH", {
    meta_json: { greenBelow: !greenBelow },
  })
    .then(() => (triggerTargets ? triggerTargets() : null))
    .catch((error) => {
      console.error("Error toggling greenBelow", error);
    });
};

function EditIndicatorForm(props) {
  let { indicator, projectId, commitId, trackerId, baseMetrics, dispatch, toggleShowHandler } = props;
  return (
    <div className="row">
      <div className="col-sm-12 align-middle">
        <CreateIndicatorForm
          projectId={projectId}
          trackerId={trackerId}
          commitId={commitId}
          baseMetrics={baseMetrics}
          dispatch={dispatch}
          toggleShowHandler={toggleShowHandler}
          indicator={indicator}
          dispatchType={"PUT"}
        />
      </div>
    </div>
  );
}

function SetTargetFormModal(props) {
  const { hideModal } = useModal();
  return (
    <Modal title="Set indicator target">
      <MetricTargetSet header={<></>} {...props} closeButtonHandler={() => hideModal()} />
    </Modal>
  );
}

export default function ProjectIndicatorRow(props) {
  const [showSetTargetForm, setShowSetTargetForm] = useState(false);
  const [showEditForm, setShowEditForm] = useState(false);
  const { setModal } = useModal();

  let { baseMetrics, indicator, projectId } = props;

  // Merge metrics from indicator with global list
  const indicatorBaseMetricsById = (indicator.get("baseMetrics") || Im.List()).reduce((acc, item) => {
    return acc.set(item.get("uid"), item);
  }, Im.Map());
  let _baseMetrics = (baseMetrics || Im.Map()).merge(indicatorBaseMetricsById);

  const showTargetForm = () => setModal(<SetTargetFormModal {...props} onClose={() => setModal(null)} />);

  return (
    <ErrorBoundary>
      <IndicatorRowWrapper
        projectId={projectId}
        baseMetrics={_baseMetrics}
        indicator={indicator}
        dropDownLinks={getDropDownLinks({ ...props, showTargetForm })}
      />
      <ErrorBoundary>
        <Hide when={!showEditForm}>
          <EditIndicatorForm
            {...props}
            {...{ showEditForm, setShowEditForm }}
            toggleShowHandler={() => setShowEditForm(!showEditForm)}
          />
        </Hide>
      </ErrorBoundary>
    </ErrorBoundary>
  );
}

// Wrapper to handle project permissions
function IndicatorRowWrapper(props) {
  let { projectId, dropDownLinks } = props;
  let { isAdmin } = useProjectPermissions(projectId);
  let _props = {
    ...props,
    dropDownLinks: isAdmin ? dropDownLinks : [],
  };

  return <IndicatorRow {..._props} />;
}
